import { useParams } from 'react-router-dom';
import {
  Box,
  Button,
  Heading,
  Text,
  VStack,
  HStack,
  Card,
  Badge,
  Separator,
  Table,
  SimpleGrid,
} from '@chakra-ui/react';

function QuoteDetail() {
  const { id } = useParams();

  // Mock data - will be replaced with real API call
  const quote = {
    id,
    quote_number: 'Q-2025-001',
    client: "John's Bakery",
    email: 'john@bakery.com',
    status: 'sent',
    created_at: '2025-09-20',
    valid_until: '2025-10-20',
    project_type: 'WordPress Website',
    timeline: '3-4 weeks',
    items: [
      {
        category: 'Development',
        name: 'WordPress Setup',
        description: 'Installation and configuration',
        quantity: 1,
        unit_price: 500,
        total: 500,
      },
      {
        category: 'Design',
        name: 'Custom Theme',
        description: 'Bakery-themed design',
        quantity: 1,
        unit_price: 1500,
        total: 1500,
      },
      {
        category: 'Content',
        name: 'Content Writing',
        description: 'Professional content for 5 pages',
        quantity: 5,
        unit_price: 100,
        total: 500,
        is_optional: true,
      },
    ],
    total_amount: 2500,
  };

  return (
    <Box>
      <VStack gap={8} align="stretch">
        {/* Header */}
        <HStack justifyContent="space-between">
          <VStack align="start" gap={2}>
            <HStack gap={3}>
              <Heading>{quote.quote_number}</Heading>
              <Badge colorScheme="blue" size="lg">
                {quote.status}
              </Badge>
            </HStack>
            <Text color="gray.600">Created on {quote.created_at}</Text>
          </VStack>

          <HStack gap={3}>
            <Button variant="outline">Download PDF</Button>
            <Button colorScheme="brand">Send to Client</Button>
          </HStack>
        </HStack>

        {/* Client Details */}
        <Card.Root>
          <Card.Body>
            <VStack gap={4} align="stretch">
              <Heading size="md">Client Information</Heading>
              <SimpleGrid columns={2} gap={4}>
                <VStack align="start">
                  <Text fontSize="sm" color="gray.600">
                    Company
                  </Text>
                  <Text fontWeight="medium">{quote.client}</Text>
                </VStack>
                <VStack align="start">
                  <Text fontSize="sm" color="gray.600">
                    Email
                  </Text>
                  <Text fontWeight="medium">{quote.email}</Text>
                </VStack>
                <VStack align="start">
                  <Text fontSize="sm" color="gray.600">
                    Project Type
                  </Text>
                  <Text fontWeight="medium">{quote.project_type}</Text>
                </VStack>
                <VStack align="start">
                  <Text fontSize="sm" color="gray.600">
                    Timeline
                  </Text>
                  <Text fontWeight="medium">{quote.timeline}</Text>
                </VStack>
              </SimpleGrid>
            </VStack>
          </Card.Body>
        </Card.Root>

        {/* Quote Items */}
        <Card.Root>
          <Card.Body>
            <VStack gap={4} align="stretch">
              <Heading size="md">Services & Pricing</Heading>

              <Table.Root>
                <Table.Header>
                  <Table.Row>
                    <Table.ColumnHeader>Service</Table.ColumnHeader>
                    <Table.ColumnHeader>Description</Table.ColumnHeader>
                    <Table.ColumnHeader textAlign="center">Qty</Table.ColumnHeader>
                    <Table.ColumnHeader textAlign="right">Unit Price</Table.ColumnHeader>
                    <Table.ColumnHeader textAlign="right">Total</Table.ColumnHeader>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {quote.items.map((item, index) => (
                    <Table.Row key={index}>
                      <Table.Cell>
                        <VStack align="start" gap={1}>
                          <Text fontWeight="medium">{item.name}</Text>
                          <Badge size="sm" variant="subtle">
                            {item.category}
                          </Badge>
                          {item.is_optional && (
                            <Badge size="sm" colorScheme="yellow">
                              Optional
                            </Badge>
                          )}
                        </VStack>
                      </Table.Cell>
                      <Table.Cell>
                        <Text fontSize="sm" color="gray.600">
                          {item.description}
                        </Text>
                      </Table.Cell>
                      <Table.Cell textAlign="center">{item.quantity}</Table.Cell>
                      <Table.Cell textAlign="right">${item.unit_price}</Table.Cell>
                      <Table.Cell textAlign="right" fontWeight="medium">
                        ${item.total}
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table.Root>

              <Separator />

              <HStack justifyContent="space-between" px={4}>
                <Text fontSize="lg" fontWeight="bold">
                  Total Amount
                </Text>
                <Heading size="lg" color="brand.500">
                  ${quote.total_amount}
                </Heading>
              </HStack>

              <Text fontSize="sm" color="gray.600" px={4}>
                Quote valid until {quote.valid_until}
              </Text>
            </VStack>
          </Card.Body>
        </Card.Root>
      </VStack>
    </Box>
  );
}

export default QuoteDetail;